import { motion } from "framer-motion";
import { Download as DownloadIcon, ShieldAlert } from "lucide-react";

// Points at the latest GitHub Release asset — update the repo path if it ever moves. Exported so
// FreeScanPromo's CTA points at the exact same download, not a second copy of this URL.
export const DOWNLOAD_URL = "https://github.com/m3psiscool-creator/flowtweaks-app/releases/latest/download/Flow-Tweaks-Setup.exe";

export const Download = () => {
  return (
    <section id="download" className="relative py-24 sm:py-32 overflow-hidden" data-testid="download-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-orange-500 font-bold tracking-[0.3em] text-xs uppercase mb-4">
          Get The App
        </p>
        <h2
          className="text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tighter leading-[0.95] mb-6"
          style={{ fontFamily: "'Orbitron', sans-serif" }}
        >
          Download, sign in,
          <br />
          <span className="text-orange-500">unlock your tweaks.</span>
        </h2>
        <p className="text-zinc-400 max-w-xl mx-auto mb-10">
          The PC plan is purchased and unlocked directly inside the app now — no Discord ticket
          needed. Download it, sign in from the Account tab, then pay (or redeem an access code)
          from the Billing tab.
        </p>

        <a
          href={DOWNLOAD_URL}
          className="glass-hover inline-flex items-center gap-3 bg-orange-500 hover:bg-orange-400 text-black font-black uppercase tracking-[0.2em] text-sm px-10 py-5 rounded-full transition-all hover:shadow-[0_0_30px_rgba(255,94,0,0.5)]"
          data-testid="download-cta"
        >
          <DownloadIcon className="w-5 h-5" />
          Download for Windows
        </a>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10% 0px" }}
          transition={{ duration: 0.5 }}
          className="glass !rounded-2xl mt-10 max-w-lg mx-auto p-6 text-left"
        >
          <div className="flex items-start gap-3">
            <ShieldAlert className="w-5 h-5 text-orange-500 shrink-0 mt-0.5" />
            <div>
              <p className="text-sm font-bold uppercase tracking-wide text-white mb-2">
                Windows may show a blue "protected your PC" screen
              </p>
              <p className="text-sm text-zinc-400 leading-relaxed">
                We're a small operation and haven't been able to afford a Windows code-signing
                certificate yet — that's the only thing that removes this warning, it doesn't mean
                anything is wrong with the app. Click{" "}
                <span className="text-white font-semibold">"More info"</span>, then{" "}
                <span className="text-white font-semibold">"Run anyway"</span> to continue. We're
                working on getting signed as the business grows.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
